(function () {
  function initSlideshow(slider) {
    if (slider.dataset.kyrosSlideshowInit) return;
    slider.dataset.kyrosSlideshowInit = '1';

    const slides = slider.querySelectorAll('.slideshow__slide');
    const dots = slider.querySelectorAll('.slideshow__dot');
    const prevBtn = slider.querySelector('.slideshow__arrow--prev');
    const nextBtn = slider.querySelector('.slideshow__arrow--next');
    const progress = slider.querySelector('.slideshow__progress');
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed, 10) || 5000;

    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;

    function setAria() {
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    function restartProgress() {
      if (!progress || !autoplay) return;
      progress.classList.remove('is-running');
      void progress.offsetWidth;
      progress.classList.add('is-running');
    }

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');
      setAria();
      restartProgress();
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function stopAuto() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (progress) progress.classList.remove('is-running');
    }

    function startAuto() {
      if (!autoplay) return;
      stopAuto();
      timer = setInterval(next, speed);
      restartProgress();
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        stopAuto();
        goTo(i);
        startAuto();
      });
    });

    prevBtn?.addEventListener('click', () => {
      stopAuto();
      prev();
      startAuto();
    });

    nextBtn?.addEventListener('click', () => {
      stopAuto();
      next();
      startAuto();
    });

    let touchStartX = 0;
    slider.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.touches[0].clientX;
      },
      { passive: true }
    );
    slider.addEventListener(
      'touchend',
      (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          stopAuto();
          if (diff > 0) next();
          else prev();
          startAuto();
        }
      },
      { passive: true }
    );

    if (autoplay) {
      slider.addEventListener('mouseenter', stopAuto);
      slider.addEventListener('mouseleave', startAuto);
      startAuto();
    }
  }

  function initAll() {
    document.querySelectorAll('.slideshow').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail?.sectionId;
    if (!sectionId) return;
    const sectionEl = document.getElementById('shopify-section-' + sectionId);
    sectionEl?.querySelectorAll('.slideshow').forEach((el) => {
      delete el.dataset.kyrosSlideshowInit;
      initSlideshow(el);
    });
  });
})();
